__turbopack_context__.v({
  "container": "AdultModal-module__xpwima__container",
  "disclaimer": "AdultModal-module__xpwima__disclaimer",
  "hidden": "AdultModal-module__xpwima__hidden",
  "modal": "AdultModal-module__xpwima__modal",
  "title": "AdultModal-module__xpwima__title",
});
